import fetchWrapper from './fetchWrapper';

const BASE = process.env.REACT_APP_BASE_API_URL || process.env.REACT_APP_TICKETING_API_URL || '';

export async function getUserProfile() {
  const url = BASE ? `${BASE.replace(/\/$/, '')}/base/user/userProfile` : '/api/base/user/userProfile';
  const res = await fetchWrapper(url);
  return res.json;
}
